import { useEffect, useState } from 'react'

import * as T from 'types'

/**
 * Note: when the map bounds change, the resulting swr key string has different coordinates, so
 * it no longer matches the key where the data lives in the cache. This means that the data is
 * undefined until the new listings are fetched
 *
 * We want to continue to show the previous listings during the refetching period so that there
 * isn't a blinking effect where markers pop out and back in
 */
const useDisplayListings = (mapListings: T.IListing[] | undefined) => {
  const [prevMapListings, setPrevMapListings] = useState<T.IListing[]>()

  useEffect(() => {
    if (mapListings) setPrevMapListings(mapListings)
  }, [mapListings])

  const displayListings = mapListings || prevMapListings

  return displayListings
}

export default useDisplayListings
